function collapsable() {

    document.querySelectorAll(".collapsible-item").forEach(function(collapsible){
        collapsible.onclick = function(collapsibleItem) {
            
            collapsible.classList.toggle("active");
            var indicatorSign = collapsible.querySelector(".expand .sign");
            indicatorSign.innerHTML = (indicatorSign.innerHTML == '+') ? '-' : '+';
        }
    });
}
export default collapsable;